// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or vendor/assets/javascripts of plugins, if any, can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// the compiled file.
//
// WARNING: THE FIRST BLANK LINE MARKS THE END OF WHAT'S TO BE PROCESSED, ANY BLANK LINE SHOULD
// GO AFTER THE REQUIRES BELOW.
//
//= require jquery

import "../styles/application.scss"
require.context("../images", true)

$(document)
.ready( function() {
	$.ajaxPrefilter( function( options, originalOptions, jqXHR ) {
		jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content') )
	})
})
.on('click','a[data-method=delete]',function(e){
	var $this = $(this);
	if( confirm( $this.attr('data-confirm') ) ) {
		$.ajax({
			url: $this.attr('href'),
			type: 'DELETE',
			beforeSend: function(jqXHR, settings) { jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content')); },
			success: function(r) { document.location.reload() }
		})
	}
	e.preventDefault();
})
.on({
	mouseenter: function() {
		var $this = $(this),
			$inner = $this.next('.inner')
		if( ($this.offset().left + 450) > window.innerWidth ) $inner.css({ marginLeft: window.innerWidth - ($this.offset().left + 470)  +'px'})


		open_help = setTimeout( function() { $inner.show() },200)
	},
	mouseleave: function() {
		if( typeof open_help != 'undefined' ) clearTimeout(open_help);
		$(this).nextAll('.inner').hide()
	}
},'.tooltip img')

function selectText(container) {
  if (document.selection) {
    var range = document.body.createTextRange();
    range.moveToElementText(container);
    range.select();
  } else if (window.getSelection) {
    var range = document.createRange();
    range.selectNode(container);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
String.prototype.plural = function(){
	var word = this,
		last_letter = this.split('').reverse()[0]

	switch(last_letter) {
		case 'y':
			return word.slice(0,-1)+'ies';
		case 's':
			return word;
		default:
			return word+'s';
	}
}
